import React from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import './ParagraphHeader.scss';

export interface ParagraphHeaderInputs {
    heading: string;
    subheading: string;
    number?: string;
}

export const ParagraphHeader = ({
    inputs,
}: {
    inputs: ParagraphHeaderInputs;
}) => {
    const { isPolicy } = useLayoutContext();

    // The use of an additional element, the 'aria-hidden' attribute,
    // and the 'kite-visually-hidden' class allows all of the main heading text to be
    // in one element for screen readers while still aligning with designs
    return (
        <div className="paragraph-header">
            {inputs?.number && (
                <span className="paragraph-header__number" aria-hidden>
                    {inputs?.number}
                    <a
                        id={encodeURIComponent(inputs.heading)}
                        className={`paragraph-header__anchor${
                            isPolicy ? `--policy` : ``
                        }`}
                    />
                </span>
            )}
            <div className="paragraph-header__heading-wrapper">
                {!inputs?.number && (
                    <a
                        id={encodeURIComponent(inputs.heading)}
                        className={`paragraph-header__anchor${
                            isPolicy ? `--policy` : ``
                        }`}
                    />
                )}
                <h2>
                    {inputs?.number && (
                        <span className="kite-visually-hidden">
                            {inputs?.number}
                        </span>
                    )}
                    <span className="paragraph-header__heading">
                        {inputs.heading}
                    </span>
                </h2>
                {inputs?.subheading && (
                    <p className="paragraph-header__subheading">
                        {inputs?.subheading && (
                            <span>{inputs?.subheading}</span>
                        )}
                    </p>
                )}
            </div>
        </div>
    );
};
